export const timeout = (duration: number): Promise<never> => new Promise(
  (_, reject) => setTimeout(() => reject("timeout"), duration)
);
